module.exports = require("pdfmake/build/pdfmake.js");


//////////////////
// WEBPACK FOOTER
// external "pdfmake/build/pdfmake.js"
// module id = nJOF
// module chunks = 33